// @generated by protoc-gen-es v2.9.0 with parameter "target=ts"
// @generated from file squareup/objc/objc.proto (package squareup.objc, syntax proto2)
/* eslint-disable */

import type { GenExtension, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { extDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EnumOptions, FieldOptions, FileOptions, MessageOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file squareup/objc/objc.proto.
 */
export const file_squareup_objc_objc: GenFile = /*@__PURE__*/
  fileDesc("ChhzcXVhcmV1cC9vYmpjL29iamMucHJvdG8SDXNxdWFyZXVwLm9iamMiMgoMQ2xhc3NPcHRpb25zEgwKBG5hbWUYASABKAkSFAoMbmFtZV9tdXRhYmxlGAIgASgJIjUKD1Byb3BlcnR5T3B0aW9ucxIMCgRuYW1lGAEgASgJEhQKDGFzX3ByaW1pdGl2ZRgCIAEoCDo+CgtmaWxlX3ByZWZpeBIcLmdvb2dsZS5wcm90b2J1Zi5GaWxlT3B0aW9ucxi4MyABKAlSCmZpbGVQcmVmaXg6YgoNY2xhc3Nfb3B0aW9ucxIfLmdvb2dsZS5wcm90b2J1Zi5NZXNzYWdlT3B0aW9ucxi4MyABKAsyGy5zcXVhcmV1cC5vYmpjLkNsYXNzT3B0aW9uc1IMY2xhc3NPcHRpb25zOmkKEHByb3BlcnR5X29wdGlvbnMSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGLgzIAEoCzIeLnNxdWFyZXVwLm9iamMuUHJvcGVydHlPcHRpb25zUg9wcm9wZXJ0eU9wdGlvbnM6OgoJZW51bV9uYW1lEhwuZ29vZ2xlLnByb3RvYnVmLkVudW1PcHRpb25zGLgzIAEoCVIIZW51bU5hbWU", [file_google_protobuf_descriptor]);

/**
 * @generated from message squareup.objc.ClassOptions
 */
export type ClassOptions = Message<"squareup.objc.ClassOptions"> & {
  /**
   * The name of the class that we want.
   *
   * @generated from field: optional string name = 1;
   */
  name: string;

  /**
   * The name of the mutable version.
   * We'd call this mutable_name, but we can't since there is a name collision.
   *
   * @generated from field: optional string name_mutable = 2;
   */
  nameMutable: string;
};

/**
 * Describes the message squareup.objc.ClassOptions.
 * Use `create(ClassOptionsSchema)` to create a new message.
 */
export const ClassOptionsSchema: GenMessage<ClassOptions> = /*@__PURE__*/
  messageDesc(file_squareup_objc_objc, 0);

/**
 * @generated from message squareup.objc.PropertyOptions
 */
export type PropertyOptions = Message<"squareup.objc.PropertyOptions"> & {
  /**
   * Overrides the default property name.
   * This is also valid for extensions too.
   *
   * @generated from field: optional string name = 1;
   */
  name: string;

  /**
   * Should we box or unbox this.  Only valid for numeric or enum values
   * If it isn't set, a primitive will be used if the field has a default value
   * (you since you don't have to worry about null case if there's a default).
   *
   * @generated from field: optional bool as_primitive = 2;
   */
  asPrimitive: boolean;
};

/**
 * Describes the message squareup.objc.PropertyOptions.
 * Use `create(PropertyOptionsSchema)` to create a new message.
 */
export const PropertyOptionsSchema: GenMessage<PropertyOptions> = /*@__PURE__*/
  messageDesc(file_squareup_objc_objc, 1);

/**
 * Specifies a default prefix for names in this file.
 * The default if not specified, use the package name with underscores as separators as a prefix.
 * Objective-C has no namespaces, so it relies on class prefixes.
 *
 * @generated from extension: optional string file_prefix = 6584;
 */
export const file_prefix: GenExtension<FileOptions, string> = /*@__PURE__*/
  extDesc(file_squareup_objc_objc, 0);

/**
 * Overrides the default name with this. If this is set, file_class_prefix is ignored.
 *
 * @generated from extension: optional squareup.objc.ClassOptions class_options = 6584;
 */
export const class_options: GenExtension<MessageOptions, ClassOptions> = /*@__PURE__*/
  extDesc(file_squareup_objc_objc, 1);

/**
 * @generated from extension: optional squareup.objc.PropertyOptions property_options = 6584;
 */
export const property_options: GenExtension<FieldOptions, PropertyOptions> = /*@__PURE__*/
  extDesc(file_squareup_objc_objc, 2);

/**
 * Overrides the default name with this. If this is set, file_class_prefix is ignored.
 *
 * @generated from extension: optional string enum_name = 6584;
 */
export const enum_name: GenExtension<EnumOptions, string> = /*@__PURE__*/
  extDesc(file_squareup_objc_objc, 3);

